import Vue from 'vue';
import CheckoutSuccessView from '../CheckoutSuccessView/CheckoutSuccessView.vue';
import {Store} from 'vuex';
import {RootState} from '../../../store';
import {DELETE_CART} from '../../../store/commits';

export class CheckoutSuccess {
  constructor(checkoutSuccessElement: Element, dataElement: any, store: Store<RootState>, i18n) {
    const dataLayerData = localStorage.getItem('dataLayerData');
    if (dataLayerData) {
      // @ts-ignore
      window.dataLayer.push(JSON.parse(dataLayerData));
      localStorage.removeItem('dataLayerData');
    }
    store.commit(DELETE_CART);

    // @ts-ignore
    new Vue({
      el: checkoutSuccessElement,
      template: `
        <checkout-success-view
          ticket-shop-url="${dataElement.ticketShopPage}"
          login-url="${dataElement.login}"
          login-page-url="${dataElement.loginPage}"
          inventory-url="${dataElement.inventory}"
        />`,
      components: {CheckoutSuccessView},
      store,
      // @ts-ignore
      i18n,
    });
  }
}
